export enum NFTSTypes {
  weapon = 'weapon',
  spaceship = 'spaceship',
  shield = 'shield',
  repairKit = 'repair Kit',
}
